import { useEffect, useState } from "react";
import { useGamification } from "@/contexts/GamificationContext";
import { markBadgesAsSeen } from "@/lib/badges";
import { supabase } from "@/integrations/supabase/client";
import { BadgeUnlockModal } from "./BadgeUnlockModal";

interface BadgeNotificationProps {
  badgeIds: string[];
  onDismiss: () => void;
}

export const BadgeNotification = ({ badgeIds, onDismiss }: BadgeNotificationProps) => {
  const [showModal, setShowModal] = useState(false);
  const { settings } = useGamification();
  const calmMode = settings?.hideRewards;

  useEffect(() => {
    if (badgeIds.length > 0) {
      // Delay 800ms so it doesn't compete with "expense saved" toast
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 800);
      
      // Mark badges as seen in database
      const markSeen = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          await markBadgesAsSeen(user.id, badgeIds);
        }
      };
      markSeen();

      // Track analytics
      badgeIds.forEach(badgeId => {
        console.log('[Badge earned]', badgeId);
      });

      return () => clearTimeout(timer);
    }
  }, [badgeIds]);

  const handleClose = () => {
    setShowModal(false);
    onDismiss();
  };

  return (
    <BadgeUnlockModal
      badgeIds={badgeIds}
      open={showModal}
      onClose={handleClose}
      calmMode={calmMode}
    />
  );
};
